import { Box } from '@mui/material';
import { NotificationDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { makePreloadedComponent } from '../../../ui/components/higher-order/preloaded.component';
import { Notification, NotificationProps } from './notification.component';
import { NotificationTooltip } from './notification-tooltip.component';

export function MultipleNotificationColumn({
  notifications,
  iconSize,
  align,
  maxVisibleNotifications
}: {
  notifications: NotificationDto[] | undefined;
  iconSize?: string;
  align?: 'left' | 'center' | 'right';
  maxVisibleNotifications: number;
}) {
  // If there are no notifications then don't render anything
  if (!notifications || notifications.length === 0) {
    return <></>;
  }

  // Prepare the notification props for rendering
  const notificationListProps = makeNotificationListProps(notifications, iconSize, maxVisibleNotifications);
  return (
    <Box
      style={{
        display: 'flex',
        width: '100%',
        justifyContent: align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : align
      }}
    >
      {notifications.length > maxVisibleNotifications && (
        <span style={{ marginRight: '3px' }}>{notifications.length - maxVisibleNotifications}+</span>
      )}
      {notificationListProps.map((props) => {
        return <Notification key={props.notification.id} {...props} />;
      })}
    </Box>
  );
}

function makeNotificationListProps(
  notifications: NotificationDto[],
  iconSize: string | undefined,
  maxVisible: number
): NotificationProps[] {
  // We want to order the notifications their date ascending, and then only show up until the maxVisible count.
  // This is because we want to show the most recent notifications first.
  notifications = notifications.sort((a, b) => {
    return a.latestStatusAt.getTime() - b.latestStatusAt.getTime();
  });

  // The array is already sorted in ascending order, so we can just slice the last maxVisible notifications (backwards)
  return notifications.slice(-maxVisible).map((notification) => {
    return {
      notification,
      iconSize,
      tooltip: makePreloadedComponent(NotificationTooltip, {
        notification
      })
    };
  });
}
